export default (min, max) => min + Math.floor(Math.random() * (max - min))
